<div class="card" style="padding: 10px;">
    <div class="row">
        <div class="col-12 d-flex justify-content-end">
            <button class="btn btn-sm btn-dark mb-1" (click)="exportPTPreport()">EXPORT</button>
        </div>
    </div>
 <div class="row">
 <div class="col-md-12">
    <div class="col-md-2">
        <label>Select Start Date</label>
    <input type="date" class="form-control" placeholder="Text Search" [(ngModel)]="ptp_start_date">
    </div>
    <div class="col-md-2">
        <label>Select End Date</label>
    <input type="date" class="form-control" placeholder="Text Search" [(ngModel)]="ptp_end_date">
    </div>
    <div class="col-md-2">
        <label>Select Portfolio</label>
        <select [(ngModel)]="agent_search" class="form-control" >
            <option *ngFor="let item of portfolio_list" [value]="item._id">{{item.portfolio_type}}</option>
        </select>
    </div>
    <div  class="col-md-4">
        <label>Action</label><br>
        <button class="btn btn-sm btn-dark mb-1" (click)="datesearch()">
            Search
        </button>
        <button style="margin-left: 10px;" class="btn btn-sm btn-dark mb-1" (click)="clear()">
            Clear
        </button>
        <button style="margin-left: 10px;" class="btn btn-sm btn-dark mb-1" (click)="exportAsXLSX()">
            Export Excel
        </button>
        <button style="margin-left: 10px;" class="btn btn-sm btn-dark mb-1" (click)="exportDetailedExcel()" [disabled]="detailed_export_status">
            Detailed Excel
        </button>
    </div>
</div>
  <table class="table">
    <thead>
        <tr>
            <th>S.No</th>
            <th>fint_id</th>
            <th>Bank</th>
            <th>Portfolio</th>
            <th>Product</th>
            <th>CIF</th>
            <th>CID</th>
            <th>Acc Number</th>
            <th>Name</th>
            <th>TOS</th>
            <th>POS</th>
            <th>CL</th>
            <th>Current Date</th>
            <th>Last Status of that day</th>
            <th>Last SubStatus of that day</th>
            <th>Follow Up date</th>
            <th>This Day remark only</th>
            <th>Agent</th>
            <th>No of attemptes for the day</th>
        </tr>
    </thead>
    <tbody>
        <tr *ngFor="let item of final_datas1 ; let i = index;">
            <td>{{i+1}}</td>
            <td>{{item.finterstal_id}}</td>
            <td>{{item.Bank}}</td>
            <td>{{item.Portfolio}}</td>
            <td>{{item.Product}}</td>
            <td>{{item.CIF}}</td>
            <td>{{item.CID}}</td>
            <td>{{item.Acc_Number}}</td>
            <td>{{item.Name}}</td>
            <td>{{item.TOS}}</td>
            <td>{{item.POS}}</td>
            <td>{{item.CL}}</td>
            <td>{{item.Current_Date | date}}</td>
            <td>{{item.Last_Status_of_that_day}}</td>
            <td>{{item.Last_SubStatus_of_that_day}}</td>
            <td>{{item.Follow_Up_date | date}}</td>
            <td>{{item.This_Day_remark_only}}</td>
            <td>{{item.Agent}}</td>
            <td>{{item.No_of_attemptes_for_the_day}}</td>
        </tr>
    </tbody>
</table>
</div>

<div class="centered" style="width: 100%;background: #000000b3;height: -webkit-fill-available;" *ngIf="detailed_export_status">
    <p><img class="imgs" src="../../../../assets/loader.gif" style="width: 10%;"></p>
    <p style="text-align: center;
    font-size: 20px;
    font-weight: 600;
    color: white;">Preparing account-wise feedback excel</p>
</div>

<div class="centered" style="width: 100%;background: #000000b3;height: -webkit-fill-available;" *ngIf="loader_status">
    <p><img class="imgs" src="../../../../assets/loader.gif" style="width: 10%;"></p>
    <p style="text-align: center;
    font-size: 20px;
    font-weight: 600;
    color: white;"> Completed {{count_down}} / {{final_datas.length}} <p>
</div>
</div>
